module.exports = __webpack_public_path__ + "static/port-operations-and-facilities-8c80a37390489aa6ac5568fcebf20e79.jpg";